export default "__VITE_ASSET__CLtjs4WN__"